import React, { Fragment } from 'react';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch,
    Avatar
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: colors.cyan[300],
        backgroundColor: colors.grey[200],
        width: 290,
        height: 290
    }
}));

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const Product = ({ item, open, closeEdition, updateValues, dependencies, clearImage, openChangeImage }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Produto
                    </Typography>
                </DialogTitle>

                <DialogContent dividers={true}>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('A seleção da unidade é obrigatório'),
                                nome: Yup.string().required('O nome da unidade é obrigatório'),
                                TIPO: Yup.string().required('O Tipo do produto é obrigatório'),
                                UNIDADE: Yup.string().required('A Unidade do produto é obrigatória'),
                                custo: Yup.string().required('O Valor de Custo do produto é precisa ser informado'),
                                valor: Yup.number().min(0.0).required('O Valor do produto é obrigatório'),
                                instalacao: Yup.number().required('O Valor de Mão de Obra do produto é obrigatório'),
                            }
                            )
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    xs="auto"
                                >

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}
                                    >

                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                            >
                                                <Avatar variant='rounded' id="productImage" name="productImage"
                                                    className={classes.avatar}
                                                    onClick={() => { openChangeImage(item) }}
                                                    src={(item.imagem) ? process.env.REACT_APP_REMOTE_REPO + '/products/' + item.imagem : null}
                                                >
                                                    Sem Imagem
                                                </Avatar>

                                            </Grid>

                                            <Grid
                                                item
                                            >

                                                <Button
                                                    disabled={!item.id}
                                                    color="secondary"
                                                    size="medium"
                                                    onClick={() => { openChangeImage(item) }}
                                                    variant="outlined">
                                                    Atualizar a Imagem
                                                </Button>
                                            </Grid>

                                            <Grid
                                                item
                                            >

                                                <Button
                                                    disabled={!item.id}
                                                    color="secondary"
                                                    size="medium"
                                                    children={<DeleteRoundedIcon />}
                                                    onClick={() => { clearImage(item) }}
                                                    variant="outlined"></Button>
                                            </Grid>

                                        </Grid>
                                        <br></br>

                                    </Grid>

                                    <Grid
                                        item
                                        md={9}
                                        xs={12}>

                                        <Grid
                                            container
                                            spacing={2}
                                            xs="auto"
                                        >
                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.codigo && errors.codigo)}
                                                    fullWidth
                                                    required
                                                    label="Código"
                                                    margin="none"
                                                    name="codigo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.codigo}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={10}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    fullWidth
                                                    required
                                                    label="Nome"
                                                    margin="none"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none" >
                                                    <InputLabel shrink htmlFor="TIPO" required>Classe de Produto</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.TIPO && errors.TIPO)}
                                                        value={values.TIPO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Classe de Produto"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'TIPO',
                                                            id: 'TIPO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.types.map((tipo) => (
                                                            <MenuItem key={tipo.id} value={tipo.id}>{tipo.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="APLICACAO">Categoria</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.APLICACAO && errors.APLICACAO)}
                                                        value={values.APLICACAO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Categoria"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'APLICACAO',
                                                            id: 'APLICACAO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.applications.map((regiao) => (
                                                            <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="marca">Marca</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.marca && errors.marca)}
                                                        value={values.marca}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Marca"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'marca',
                                                            id: 'marca',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.brandings.map((marca) => (
                                                            <MenuItem key={marca.id} value={marca.id}>{marca.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.codigoFornecedor && errors.codigoFornecedor)}
                                                    fullWidth
                                                    label="Código Fornecedor"
                                                    margin="none"
                                                    name="codigoFornecedor"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.codigoFornecedor}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={10}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="fornecedor">Fornecedor</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.fornecedor && errors.fornecedor)}
                                                        value={values.fornecedor}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Fornecedor"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'fornecedor',
                                                            id: 'fornecedor',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.providers.map((fornecedor) => (
                                                            <MenuItem key={fornecedor.id} value={fornecedor.id}>{fornecedor.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={9}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.observacao && errors.observacao)}
                                                    fullWidth
                                                    label="Observações Sobre o Produto"
                                                    rows={2}
                                                    size={10}
                                                    length={512}
                                                    multiline
                                                    margin="none"
                                                    name="observacao"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.observacao}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>


                                            <Grid
                                                item
                                                md="auto"
                                                xs="auto">
                                                <Typography
                                                    color="textPrimary"
                                                    gutterBottom
                                                    variant="h6"
                                                >
                                                    Ativo
                                                </Typography>
                                                <Switch
                                                    checked={values.ativo}
                                                    onChange={handleChange}
                                                    name="ativo"
                                                    id="ativo" />
                                            </Grid>

                                            <Grid
                                                item
                                                md="auto"
                                                xs="auto">
                                                <Typography
                                                    color="textPrimary"
                                                    gutterBottom
                                                    variant="h6"
                                                >
                                                    Controlar Estoque
                                                </Typography>
                                                <Switch
                                                    checked={values.controlado}
                                                    onChange={handleChange}
                                                    name="controlado"
                                                    id="controlado" />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <Divider></Divider>
                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <NumberFormat
                                                    error={Boolean(touched.custo && errors.custo)}
                                                    fullWidth
                                                    required
                                                    label="Valor de Custo"
                                                    margin="none"
                                                    name="custo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.custo}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <NumberFormat
                                                    error={Boolean(touched.valor && errors.valor)}
                                                    fullWidth
                                                    required
                                                    label="Valor Material"
                                                    margin="none"
                                                    name="valor"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.valor}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.instalacao && errors.instalacao)}
                                                    required
                                                    fullWidth
                                                    label="Valor Instalação"
                                                    margin="none"
                                                    name="instalacao"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.instalacao}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="UNIDADE" required>Unidade</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.UNIDADE && errors.UNIDADE)}
                                                        helperText={touched.UNIDADE && errors.UNIDADE}
                                                        value={values.UNIDADE}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Unidade"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'UNIDADE',
                                                            id: 'UNIDADE',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.units.map((unit) => (
                                                            <MenuItem key={unit.id} value={unit.id}>{unit.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>


                                        </Grid>

                                    </Grid>

                                </Grid>


                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Product;
